import slick from 'slick-carousel';
import $ from 'jquery';

export class slider {
	
		constructor() {
			
			$('.js-testimony-slider').slick({
				adaptiveHeight: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: true,
				autoplaySpeed: 15000,
				responsive: [
					{
						breakpoint: 700,
						settings: {
							adaptiveHeight: true
						}
					}
				]
			});

			
			$('.c-infoCard__Slider').slick({
				adaptiveHeight: false,
				dots: true,
				slidesToShow: 1,
				slidesToScroll: 1,
			});
		}
	
}



